// extracted by mini-css-extract-plugin
export var hidden = "_5i-1";
export var leftPanel = "_5i-2";
export var readonlyInspector = "_5i-3";
export var rightPanel = "_5i-0";